import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryBindPassengerEvent } from "../../../common/types/order-details-history-entry-event";

type OrderDetailsHistoryEntryBindPassengerContentProps = {
  event: OrderDetailsHistoryEntryBindPassengerEvent;
};

const OrderDetailsHistoryEntryBindPassengerContentComponent: FC<
  OrderDetailsHistoryEntryBindPassengerContentProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().bindPassengerEntry;

  return (
    <div className="order_details_history_entry_list_item_content">
      <div className="order_details_history_entry_list_item_content__heading_text">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryBindPassengerContentComponent;
